import * as React from 'react';
import { CircularProgress, IconButton, ListItem, ListItemText } from '@mui/material';
import { Delete } from '@mui/icons-material';

import { IZoneServiceItem } from 'models';
import { useDeleteZoneServiceItemMutation } from 'store/apis';
import { useAppSelector } from 'store/store.hook';
import { selectCurrentUserInfo } from 'store/slices/auth.slice';

interface ServiceItemProps {
  serviceItem: IZoneServiceItem;
}

export const ServiceItem = ({ serviceItem: { id, name, zone_id: zoneId } }: ServiceItemProps) => {
  const { orgSlug } = useAppSelector(selectCurrentUserInfo);
  const [mutate, { isLoading: isDeleting }] = useDeleteZoneServiceItemMutation();

  const onDelete = () => {
    mutate({ orgSlug, zoneId, id });
  };

  return (
    <ListItem
      secondaryAction={
        <IconButton
          edge="end"
          aria-label="delete"
          color="primary"
          onClick={onDelete}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 40,
            height: 40,
          }}
          disabled={isDeleting}
        >
          {isDeleting ? <CircularProgress size={18} color="inherit" /> : <Delete />}
        </IconButton>
      }
    >
      <ListItemText primary={name} />
    </ListItem>
  );
};
